import { css } from '@emotion/css';
import { repeaterPaneStyle } from 'Shared/backend/contact/ContactPage';
import { theme } from 'Shared/backend/ThemeProvider';
import { SingleSelect, Text } from 'Shared/forms/Inputs';
import { addItemAndOpen, StoreRepeater } from 'Shared/forms/StoreRepeater';
import { Wrap } from 'Shared/forms/Wrap';
import { Show } from 'solid-js';


export function ThirdPartyServicesTab(props)
{
	let servicesNode;

	return (
		<div class={css(theme().detailsPane)}>
			<h3 class={css(theme().section.blueHeading)}>Third Party Apps</h3>

			<h4 class={css(theme().section.heading)}>Add delivery, reservation and other external services.</h4>

			<StoreRepeater ref={servicesNode} {...props} page={props.page} field='thirdPartyServices' renderTitle={i => i.other ?? i.title}>
				{(item,index) => <ServiceEntry {...props} {...item} location={['thirdPartyServices',index]} index={index} />}
			</StoreRepeater>

			<button class={css(theme().button,{alignSelf:'start'})}
				onClick={() => addItemAndOpen({...props,permission:'edit',field:'thirdPartyServices'},servicesNode,{})}
			>
				<i class='fas fa-plus'/> Add social media
			</button>
		</div>
	)
}

function ServiceEntry(props)
{
	return (
		<div class={repeaterPaneStyle()}>
			<Wrap label='Name'>
				<SingleSelect {...props} field='title' options={{
					reservations: 'Reservation site',
					accommodation: 'Accomodation booking site',
					uberEats: 'Uber Eats',
					menulog: 'Menulog',
					deliveroo: 'Deliveroo',
					doordash: 'Doordash',
					other: 'Other'
				}} />
			</Wrap>

			<Show when={props.title=='other'}>
				<Wrap label='Name of other service'>
					<Text {...props} field='other' />
				</Wrap>
			</Show>

			<Wrap label='website link to your page on this service'>
				<Text {...props} field='url' />
			</Wrap>
		</div>
	);
}

